module.exports = __webpack_public_path__ + "img/202505_01_sp.6508423e.jpg";